import React from 'react';
import PropTypes from 'prop-types';
import { Button as StyledButton, CustomContent, Label } from './style';

function Button({
  children,
  className,
  color = 'default',
  component: Component,
  contentFirst = false,
  disabled,
  fullWidth,
  label,
  size = 'large',
  type = 'button',
  variant = 'contained',
  onClick,
  disabledColor,
  ...rest
}) {
  const filteredProps = { ...rest };

  if (Component && filteredProps.color == null) {
    filteredProps.color = color;
  }

  return (
    <StyledButton
      $color={color}
      $fullWidth={fullWidth}
      $size={size}
      $variant={variant}
      as={Component}
      className={className}
      disabled={disabled}
      aria-disabled={disabled}
      data-disabled={disabled}
      onClick={onClick}
      type={type}
      {...filteredProps}
    >
      {contentFirst && children}
      {label && <Label>{label}</Label>}
      {!contentFirst && children && <CustomContent>{children}</CustomContent>}
    </StyledButton>
  );
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  className: PropTypes.string,
  color: PropTypes.oneOf(['danger', 'default', 'primary', 'secondary']),
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  contentFirst: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf(['button', 'submit']),
  variant: PropTypes.oneOf([
    'contained',
    'lightContained',
    'lightOutlined',
    'lightText',
    'outlined',
    'text'
  ]),
  onClick: PropTypes.func,
  disabledColor: PropTypes.string
};

export default React.memo(Button);
